import type { QuizzesState } from 'features/quizzes/types';

export const clearQuizResults = (state: QuizzesState) => {
  state.results = {};
  state.detailedResults = {};
};
